import { AxiosResponse } from 'axios'

import { AbstractApi } from '../../../common/api'
import { CompanyData } from '../types/dadata.types'

class DadataApi extends AbstractApi {
  protected url = 'dadata'

  public companyByInnName(query?: string): Promise<AxiosResponse<{ suggestions: CompanyData[] }>> {
    return this.post<{ suggestions: CompanyData[] }>(this.url.concat('/companies'), { query })
  }
}

export const dadataApi = new DadataApi()
